require('./scaRequestModal.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');

// @core
const { FormattedText } = require('core/i18n').i18n;

// @components
const OKModal = require('components/commons/OKModal/OKModal');
const SignaturePattern = require('components/signaturePattern/signaturePattern').SignaturePattern;
const SignaturePatternButton = require('components/signaturePattern/signaturePatternButton/signaturePatternButton');

// @contants
const { REQUIRE_SCA } = require('constants/operationTypes');


class ScaRequestModal extends React.Component {
    buildContent() {
        return (
            <SignaturePattern
                operationType={REQUIRE_SCA}
                operationParams={{}}
            />
        );
    }

    buildConfirmButton() {
        const { loading, onPrimaryButtonClick } = this.props;
        return (
            <SignaturePatternButton
                onClick={onPrimaryButtonClick}
                loading={loading}
            >
                <FormattedText value="scaModal-confirm" />
            </SignaturePatternButton>
        )
    }

    render() {
        const { visible, onCloseCallback, phone, getTitleAndDescription, showPN } = this.props;
        const content = this.buildContent();
        const confirmButton = this.buildConfirmButton();
        const titleString = (!!getTitleAndDescription && showPN) ? getTitleAndDescription('scaModal-pushNotificationTitle', 'scaModal-genericTitle', 'scaModal-title') : 'scaModal-title';
        const descriptionString = (!!getTitleAndDescription && showPN) ? getTitleAndDescription('scaModal-pushNotificationDescription', 'scaModal-genericDescription', 'scaModal-description') : 'scaModal-description';
        const description = <FormattedText value={descriptionString} injectedStrings={[phone]} />;

        return (
            <div className="sca-modal-request">
                <OKModal
                    title={titleString}
                    titleAlignment="center"
                    description={description}
                    descriptionAlignment="center"
                    contentOverflow="auto"
                    content={content}
                    footerType="navigation"
                    isOpen={visible}
                    onCloseCallback={onCloseCallback}
                    onSecondaryButtonClick={onCloseCallback}
                    secondaryButtonText="scaModal-back"
                    type="filter"
                    overlayClassName="sca-modal-request"
                    primaryButtonCustom={confirmButton}
                />
            </div>
        )
    }
}

ScaRequestModal.propTypes = {
    getTitleAndDescription: PropTypes.func,
    loading: PropTypes.bool.isRequired,
    onCloseCallback: PropTypes.func.isRequired,
    onPrimaryButtonClick: PropTypes.func.isRequired,
    phone: PropTypes.string.isRequired,
    showPN: PropTypes.bool,
    visible: PropTypes.bool.isRequired,
};

ScaRequestModal.defaultProps = {
    loading: false,
    showPN: false
}

module.exports = ScaRequestModal;
